module.exports = __webpack_public_path__ + "img/2.1326b292.png";